module.exports = __webpack_public_path__ + "static/media/11.d1f5cced.png";